import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Value from './value';
import { USD } from 'helpers/formatters/number_formats';

export function CurrencyValue({ deal, name, value, ...props }) {
  value = value || deal[name];
  if (value) {
    value = USD.format(value);
  }

  return <Value {...props} name={name} value={value} />;
}

CurrencyValue.propTypes = {
  deal: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(CurrencyValue);
